module.exports = __webpack_public_path__ + "static/Crowns 2 intraoral before-13719c6e8e9418d7b97b9c832ad48461.jpg";